import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoMaterialModule } from '../material/material.module';
import { HeaderComponent } from '../layout/header/header.component';
import { FooterComponent } from '../layout/footer/footer.component';
import { LeftmenuComponent } from '../layout/leftmenu/leftmenu.component';
import { AuthService } from '../services/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiservicesService } from '../services/apiservices.service';
import { ListingAngular15Module } from 'listing-angular15';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LeftmenuComponent,
   
  ],
  imports: [
    CommonModule,
    DemoMaterialModule,
    HttpClientModule,
    ListingAngular15Module,
  ],
  exports: [
    DemoMaterialModule,
    HeaderComponent,
    FooterComponent,
    LeftmenuComponent,
    ListingAngular15Module,
  ],
  providers: [ApiservicesService,  AuthService],
  bootstrap: [
    
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
  ],
 
})
export class SharedModule { }
